import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { IMAGES } from "../data/site";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate(user.role === "librarian" ? "/librarian" : "/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate(res.user?.role === "librarian" ? "/librarian" : "/admin");
    else setError(res.error);
  };

  return (
    <div data-testid="login-page" className="min-h-screen grid grid-cols-1 lg:grid-cols-2">
      <div className="relative hidden lg:block overflow-hidden">
        <img src={IMAGES.campus} alt="Campus" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-forest/70" />
        <div className="relative z-10 h-full flex flex-col justify-end p-16 text-bone">
          <h2 className="font-serif text-5xl tracking-tight leading-none">
            Kanggui <span className="italic text-gold-light">Christian</span> College
          </h2>
          <p className="text-bone/60 mt-4">Administrator Portal · Notice Management</p>
        </div>
      </div>

      <div className="flex items-center justify-center bg-bone px-6 py-24">
        <form onSubmit={submit} className="w-full max-w-sm fade-up">
          <div className="w-12 h-12 rounded-full bg-forest text-bone flex items-center justify-center mb-8">
            <Lock size={20} />
          </div>
          <h1 className="font-serif text-4xl text-forest tracking-tight">Admin Login</h1>
          <p className="text-muted mt-2 mb-8">Sign in to manage the notice board.</p>

          {error && (
            <div data-testid="login-error" className="mb-6 text-sm text-destructive bg-destructive/10 border border-destructive/30 px-4 py-3 rounded-sm">
              {error}
            </div>
          )}

          <label className="block text-xs uppercase tracking-widest text-forest/60 mb-2">Email</label>
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full bg-transparent border border-line focus:border-gold outline-none px-4 py-3 rounded-sm mb-6 focus:ring-2 focus:ring-gold/30"
          />

          <label className="block text-xs uppercase tracking-widest text-forest/60 mb-2">Password</label>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full bg-transparent border border-line focus:border-gold outline-none px-4 py-3 rounded-sm mb-8 focus:ring-2 focus:ring-gold/30"
          />

          <button
            data-testid="login-submit"
            type="submit"
            disabled={busy}
            className="w-full bg-forest text-bone py-4 rounded-full text-sm uppercase tracking-widest hover:-translate-y-0.5 transition-transform disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
